import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { LoadingComponent } from './loading/loading.component';
// import { HeaderComponent } from './header/header.component';
// import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { FileUploaderInputComponent } from './file-uploader-input/file-uploader-input.component';
import { DashboardComponentsModule } from '@components/dashboard-components.module';



@NgModule({
  declarations: [
    SidebarComponent,
    LoadingComponent,
    // HeaderComponent,
    // FooterComponent,
    FileUploaderInputComponent
  ],
  imports: [
    RouterModule,
    CommonModule
  ],
  exports: [
    SidebarComponent,
    LoadingComponent,
    // HeaderComponent,
    // FooterComponent,
    FileUploaderInputComponent,
    DashboardComponentsModule
  ]
})
export class PartialsModule { }
